{
  "slug": "what-is-the-average-iq",
  "title": "什么是平均智商?",
  "description": "平均智商是什么意思 100, 标准偏差和百分比如何工作, 以及如何负责任地解释比较.",
  "summary": "在大多数现代智商尺度上,平均值设置为 100参考人口的大约三分之二属于 年龄段。 85 及 115.",
  "sections": [
    {
      "heading": "为什么平均值是 100",
      "paragraphs": [
        "智商测试是标准化的,而不是基于一个固定的正确答案数量。 出版商将原始结果转换为参考组的平均值。 100随着人口和教育经验的变化，测试定期重新标准化。",
        "近音符 100 表示表现接近所选准则组的中点,而不是有人回答了 的表现。 100 一个人拥有一定数量的智力。"
      ]
    },
    {
      "heading": "共同體 85–115 范围",
      "paragraphs": [
        "标准偏差为 的 15, 关于 68一个正态分布的百分比是从 85 托 115, 约. 95占总数的百分比 70 托 130这些都是近似值。",
        "百分比可以更容易理解: 100 是靠近 50百分位数， 115 附近的 84二十一世紀 85 附近的 16塔，哈。"
      ]
    },
    {
      "heading": "谨慎使用比较",
      "paragraphs": [
        "评分需要适当的年龄规范和当前测试版本。 语言、教育、健康和背景都很重要,跨国或人口比较对于抽样和方法特别敏感。",
        "对于个人而言,置信区间和子检验轮廓比将总数视为完全精确更有用。"
      ]
    }
  ],
  "faqs": [
    {
      "question": "伊斯 100 一个好的智商?",
      "answer": "分數 100 是规范组的中心,代表被评估能力的典型表现。"
    },
    {
      "question": "百分比的人得分以上 100?",
      "answer": "約半分以上 100 尽管实数规范分布并非完全对称,但它们的分布范围是 100% 至 100% 。"
    }
  ],
  "related": ["iq-score-ranges-explained", "what-does-an-iq-of-120-mean", "how-is-iq-measured"]
}
